import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/* EJ:  | customDate:'DD/MM/YYYY' */

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: string | Date | number, format: string): string {
    if (!value) return '';
    const date = moment.parseZone(value).format(format);
    return date;
  }

}
